import { render } from "./AutoGrowTextarea.vue?vue&type=template&id=67b28ee2&scoped=true"
import script from "./AutoGrowTextarea.vue?vue&type=script&lang=js"
export * from "./AutoGrowTextarea.vue?vue&type=script&lang=js"

import "./AutoGrowTextarea.vue?vue&type=style&index=0&id=67b28ee2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b28ee2"]])

export default __exports__